import React from 'react'
import styled from 'styled-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons'
import { useSmartNavigateLegacy as useNavigate } from 'components/SmartLink'
import { BaseButton } from 'iebt-zing-storybook'
import { Button } from 'react-bootstrap'

const AlertBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #ffffff;
  border-left: 5px solid #7318d3;
  border-radius: 6px;
  box-shadow: 0 3px 5px rgba(0, 0, 0, 0.1);
  padding: 1rem;
  margin-bottom: 1.5rem;
`

const AlertText = styled.span`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-size: 1rem;
  color: #333;
`

export const PendingUpdateAlert = (): JSX.Element => {
  const navigate = useNavigate()

  return (
    <AlertBox>
      <AlertText>
        <FontAwesomeIcon icon={faExclamationTriangle} color="#7318d3" />
        Atenção! Atualização cadastral pendente.
      </AlertText>
      <Button onClick={() => navigate('/hub/user-config')}>Atualizar cadastro</Button>
    </AlertBox>
  )
}
